exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bottom {\n  height: 32px;\n  text-align: center;\n  line-height: 32px;\n  display: inline-block;\n  padding: 0 !important;\n}\n", ""]);

// exports
